<div class="min-h-screen flex flex-col">
  <app-navigation></app-navigation>
  <div class="flex-grow background-green">
    <div class="fullscreen-background"><router-outlet></router-outlet></div>
  </div>

  <app-footer></app-footer>
</div>
